import { Howl, Howler } from 'howler'
import { Toast } from 'vant'
class Player {
  constructor(playList) {
    this.playList = playList
    this.index = 0
    this.initPlay()
  }
  initPlay() {
    this.playList.map((item) => {
      item.play = false
      item.totalTime = 0
      item.curTime = 0
      item.rate = 1
      item.sound = null
      item.loading = false
      item.disabledMove = false
    })
  }
  destroy() {
    let data = this.playList[this.index]
    data.play = false
    data.sound && data.sound.pause()
  }
  cur() {
    return this.playList[this.index]
  }
  play() {
    let index = this.index
    let data = this.playList[index]
    if (data.sound) {
      data.play = true
      if (!data.sound.playing()) {
        data.sound.play()
      }
    } else {
      this.loadAudio()
    }
  }
  loadAudio(jumpTime) {
    let index = this.index
    let data = this.playList[index]
    data.loading = true
    data.sound = new Howl({
      src: [data.url],
      format: ['mp3'],
      html5: true, //流式音频 适用于大音频
      volume: 1,
      rate: data.rate,
      autoplay: false,
      preload: 'metadata',
      onend: () => {
        data.play = false
        data?.onend()
      }, //播放结束
      onloaderror: () => {
        data.loading = false
        Toast('音频加载失败')
        data.sound = null
      },
      onload: () => {
        console.log('加载成功')
        data.loading = false
        data.totalTime = data.sound.duration()
        if (this.index == index && !data.play) {
          data.sound.rate(data.rate)
          if (jumpTime) {
            this.seek(Math.floor((data.totalTime * jumpTime) / 100))
          } else {
            this.play()
          }
        }
      },
      onplay: () => {
        this.updateStatus()
      },
      onplayerror: (id, e) => {
        Toast('音频播放失败')
        console.log(e)
      }, //声音播放失败
      onpause: () => {},
      onstop: () => {},
      onmute: () => {},
      onvolume: () => {},
      onrate: () => {}
    })
  }
  toggle() {
    let data = this.playList[this.index]
    if (data.sound) {
      if (data.play) {
        data.play = false
        data.sound.pause()
      } else {
        data.play = true
        data.sound.play()
      }
    } else {
      this.loadAudio()
    }
  }
  updateStatus() {
    let data = this.playList[this.index]
    if (data.disabledMove) {
      return
    }
    let time = data.sound.seek()
    data.curTime = Math.round(time)
    data?.onplay(this.index)
    if (data.sound.playing()) {
      requestAnimationFrame(() => {
        this.updateStatus()
      })
    }
  }
  pause() {
    let data = this.playList[this.index]
    data.sound.pause()
    data.play = false
  }
  volume(val) {
    let data = this.playList[this.index]
  }
  playHistory(time) {
    let index = this.index
    let data = this.playList[index]
    if (!data.sound) {
      this.loadAudio(time)
      return
    } else {
      this.seek(time)
    }
  }
  seek(time) {
    let data = this.playList[this.index]
    data.curTime = time
    data.sound.seek(time)
    data.play = true
    data.sound.play()
    if (time > data.totalTime) {
      data.curTime = data.totalTime
    }
  }
  bindFrontTime(time) {
    let data = this.playList[this.index]
    if (!data.play) {
      return
    }
    let jumpTime = data.curTime + time
    if (jumpTime > data.totalTime) {
      jumpTime = 0
    }
    this.seek(jumpTime)
  }
  bindBackTime(time) {
    let data = this.playList[this.index]
    if (!data.play) {
      return
    }
    let jumpTime = data.curTime - time
    if (jumpTime < 0) {
      jumpTime = 0
    }
    this.seek(jumpTime)
  }
  rate(rate) {
    let data = this.playList[this.index]
    data.rate = rate
    if (data.sound) {
      data.sound.rate(rate)
    }
  }
}
export default Player
